<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="visible">        
        <div class="area-modal u-window">           
            <div class="dialog-content">
                <div class="u-btn close" @click="closeModal"></div>
                <div class="dialog-wrapper">
                    <div class="dialog-title t-area"></div>
                    <div class="area-view">
                        <div class="area-box">
                        <p class="now" @click="listShow = true"><span>绑定大区：</span>{{ now.name }}<em class="select"></em></p>
                            <div class="area-list" v-if="listShow">
                            <vuescroll>
                                <ul>
                                    <li v-for="area in areas[account_type]"
                                    :key = "area.id"
                                    v-bind:data-aid="area.id"
                                    v-bind:data-name="area.name"
                                    @click="queryPlayer" v-html="area.name"></li>
                                </ul> 
                            </vuescroll>                       
                       </div>
                        </div>
                        <div class="player-name"><p><span>角色昵称：</span>{{ now.playerName }}</p></div>
                    </div>
                    <p class="warn"><em class="icon i-warn"></em>绑定大区后不可修改！请仔细核对参与角色。</p>
                    <div class="u-btn submit" @click="bindArea"></div>
                </div>
            </div>            
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>    
</template>

<script>
export default {
    name : 'area-modal',
    data : function (){
        return {
            listShow: false,
            now: {
                "id": 0,
                "name": "",
                "playerName": '',
            },
            areas: {
                pc: [{
                        "id": 1,
                        "name": "火烧赤壁"
                    }, {
                        "id": 2,
                        "name": "草船借箭"
                    }, {
                        "id": 6,
                        "name": "荆州之战"
                    }, {
                        "id": 7,
                        "name": "青梅煮酒"
                    }, {
                        "id": 11,
                        "name": "九伐中原"
                    }, {
                        "id": 16,
                        "name": "怀旧服"
                    }, {
                        "id": 8,
                        "name": "官渡之战"
                    }, {
                        "id": 9,
                        "name": "桃园结义"
                    }, {
                        "id": 19,
                        "name": "火凤燎原"
                    }, {
                        "id": 20,
                        "name": "卧龙出渊"
                    },{
                        "id": 23,
                        "name": "单刀赴会"
                    }],
                    wg: [{
                        "id": 1,
                        "name": "火烧赤壁"
                    }, {
                        "id": 2,
                        "name": "草船借箭"
                    }, {
                        "id": 6,
                        "name": "荆州之战"
                    }, {
                        "id": 7,
                        "name": "青梅煮酒"
                    }, {
                        "id": 11,
                        "name": "九伐中原"
                    }, {
                        "id": 16,
                        "name": "怀旧服"
                    }, {
                        "id": 8,
                        "name": "官渡之战"
                    }, {
                        "id": 9,
                        "name": "桃园结义"
                    }, {
                        "id": 19,
                        "name": "火凤燎原"
                    }, {
                        "id": 20,
                        "name": "卧龙出渊"
                    }, {
                        "id": 17,
                        "name": "铜雀台</br>(wegame1)"
                    }, {
                        "id": 18,
                        "name": "凤仪亭</br>(wegame2)"
                    },{
                        "id": 22,
                        "name": "逍遥津</br>(wegame3)"
                    }],
                steam: [{
                    "id": 1,
                    "name": "火烧赤壁"
                }, {
                    "id": 2,
                    "name": "草船借箭"
                }, {
                    "id": 6,
                    "name": "荆州之战"
                }, {
                    "id": 7,
                    "name": "青梅煮酒"
                }, {
                    "id": 11,
                    "name": "九伐中原"
                }, {
                    "id": 16,
                    "name": "怀旧服"
                }, {
                    "id": 8,
                    "name": "官渡之战"
                }, {
                    "id": 9,
                    "name": "桃园结义"
                }, {
                    "id": 19,
                    "name": "火凤燎原"
                }, {
                    "id": 20,
                    "name": "卧龙出渊"
                },{
                    "id": 21,
                    "name": "长生殿(Steam)"
                },
                ],                
                test: [{
                    "id": 1,
                    "name": "火烧赤壁"
                }, {
                    "id": 2,
                    "name": "草船借箭"
                }, {
                    "id": 6,
                    "name": "荆州之战"
                }, {
                    "id": 7,
                    "name": "青梅煮酒"
                }, {
                    "id": 11,
                    "name": "九伐中原"
                }, {
                    "id": 16,
                    "name": "怀旧服"
                }, {
                    "id": 8,
                    "name": "官渡之战"
                }, {
                    "id": 9,
                    "name": "桃园结义"
                }, {
                    "id": 19,
                    "name": "火凤燎原"
                }, {
                    "id": 20,
                    "name": "卧龙出渊"
                }, {
                    "id": 17,
                    "name": "铜雀台</br>(wegame1)"
                }, {
                    "id": 18,
                    "name": "凤仪亭</br>(wegame2)"
                },{
                    "id": 21,
                    "name": "长生殿(Steam)"
                },{
                    "id": 22,
                    "name": "逍遥津</br>(wegame3)"
                },{
                    "id": 23,
                    "name": "单刀赴会"
                }, {
                    "id": 100,
                    "name": "TEST_1"
                }, {
                    "id": 110,
                    "name": "TEST_2"
                }],                
            },
            from : {
                '1' : 'wg',
                '2' : 'steam',
                '0' : 'pc',
            },
            visible : false,
            account_type : 'pc',
            code : '',
            ua : {},
            busy : false,             
        }
    },
    watch: {
        closed (newVal) {
            if (newVal) {
                this.visible = false
                this.destroyElement()
            }
        }
    },
    created (){
        this.account_type = this.from[this.$store.state.userinfo.fromType.toString()];
        this.account_type = process.env.NODE_ENV == 'development' ? 'test' : this.account_type;
       //this.account_type = 'test'
    },           
    methods: {
        destroyElement () {
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },        
        closeModal(){
            this.destroyElement()
        },
        queryPlayer(e){
            this.listShow = false;
            var _s = e.target;
            var vue = this;
                vue.now.name = _s.getAttribute('data-name').replace('</br>', '');
                vue.now.id = _s.getAttribute('data-aid');
                        
            this.$axios.get(globalThis.ajax_url_map.queryplayer, {
                params: {
                    areaId : vue.now.id,
                }
            })
            .then(res => {
                vue.$toast('查询成功');
                vue.now.playerName = res.data.petName;      
            },
            rej => {
                vue.$toast(rej.message);
                vue.now.playerName = '';
            })
            .catch(function (error) {
                console.log(error);
            });             

        },
        bindArea(e){
            var _s = e.target;
            var vue = this;

            if(this.busy)return;

            //todo inviteCode
            if(!vue.now.id)return vue.$toast('请先选择绑定大区');
            if(!vue.now.playerName)return vue.$toast('端游未创角');

            this.busy = true;

            this.$axios.post(globalThis.ajax_url_map.bind, {
                areaId : vue.now.id,
            })
            .then(res => {
                //vue.$update();
                var _ua = res.data;
                _ua.nickName = vue.now.playerName;
                _ua.areaId = vue.now.id;

                //this.$update_ua(_ua);
                vue.$update_evt();
                vue.$query_skin();

                vue.$toast('大区绑定成功');
                
                this.busy = false;
                
                vue.destroyElement();
                     
            },
            rej => {
                this.busy = false;
                vue.$toast(rej.message);
            })
            .catch(function (error) {
                console.log(error);
            });   
        },
    },    
}
</script>

<style>

    .area-modal{
        width: 715px;
        height: 523px;
        background-image: url(~@/assets/images/bg-bind.png);
    }


    .t-area{
        width: 267px;
        height: 60px;
        margin: 15px auto 15px;
        background-image: url(~@/assets/images/title-bind.png);
    }

    .area-view{
        margin-top: 0;
    }

    .area-view .area-box {
        position: relative;
        width: 520px;
        height: 84px;
        line-height: 84px;
        margin: 0 auto 20px;
        box-sizing: border-box;
        background-color: #fbf6e8;
        color: #c47a49;
        vertical-align: middle;
        border: 1px solid #9d7361;
        border-radius: 10px;
        z-index: 10;
        font-size: 26px;
    }

    .area-box p {
        position: relative;
        padding-left: 30px;
        line-height: 84px;
        /* color: #713725; */
    }

    .area-box .now .select {
        position: absolute;
        display: block;
        content: '';
        top: 50%;
        right: 20px;
        width: 24px;
        height: 100%;
        transform: translateY(-50%);
    }

    .area-box .now .select::after{
        display: block;
        content: '';
        width: 100%;
        height: 100%;
        background-image: url(~@/assets/images/icon-select.png);
        background-size: 24px 16px;
        background-position: center;
        background-repeat: no-repeat;
    }  

    .area-box .now span {
        padding-right: 20px;
        color: #876c4a;
    }

    .area-view .area-list {
        /* display: none; */
        position: absolute;
        top: 75px;
        left: 50%;
        width: 520px;
        height: 250px;
        padding: 20px 15px 0 15px;
        background-color: #fbf6e8;
        border: 1px solid #9d7361;
        color: #876c4a;
        z-index: 50;
        box-sizing: border-box;
        transform: translateX(-50%);
        border-top: none;
        border-radius: 0 0 10px 10px;
    }

    .area-view .area-list ul{
        display: flex;
        flex-wrap: wrap;
    }

    .area-view .area-list li {
        /* display: inline-block; */
        min-width: 50%;
        min-height: 30px;
        line-height: 30px;
        margin-bottom: 15px;
        text-align: center;
        box-sizing: content-box;
    }

    .area-view .player-name {
        position: relative;
        width: 520px;
        height: 84px;
        line-height: 84px;
        margin: 0 auto 20px;
        box-sizing: border-box;
        background-color: #fbf6e8;
        color: #c47a49;
        vertical-align: middle;
        border: 1px solid #9d7361;
        border-radius: 10px;
        font-size: 26px;
    }

    .area-view .player-name p{
        
    }

    .area-view .player-name span {
        display: inline-block;
        padding-left: 30px;
        padding-right: 20px;
        color: #876c4a;      
    }


    .area-modal .u-btn.submit{
        width: 268px;
        height: 87px;
        margin: 15px auto 0;
        background-image: url(~@/assets/images/btn-submit.png);    
    }    

    .area-modal .warn{
        min-width: 544px;
        height: 43px;
        margin-top: 10px;
        margin-bottom: 15px;
        line-height: 43px;
        color: #fff5de;
        text-align: center;
        background-image: url(~@/assets/images/bg-notice.png);
        background-repeat: no-repeat;
        background-position: center;
    }

    .i-warn{
        display: inline-block;
        vertical-align: middle;
        width: 28px;
        height: 28px;
        margin-right: 15px;
        background-image: url(~@/assets/images/icon-warn.png);
    }
</style>


// WEBPACK FOOTER //
// src/components/AreaBind/areaModal.vue